import {
  AfterViewInit,
  ViewChildren,
  QueryList,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Injector,
  OnInit,
  ViewChild,
  AfterViewChecked,
  ElementRef,
  ChangeDetectionStrategy,
  OnDestroy,
  TrackByFunction
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EinvoiceStatusComponent } from '@components/einvoice/einv-status/einv-status.component';
import {
  ColumnOptions,
  COUNTRY_OPTIONS,
  EINVOICE_PAYM,
  EINVOICE_STOCK_CLASSIFICATION
} from '@core';
import { ACLService } from '@delon/acl';
import { _HttpClient, SettingsService } from '@delon/theme';
import { Store } from '@ngrx/store';
import { DeferredVatLookupService } from '@shared-feature/services/lookup-deferredvat.service';
import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzResizeEvent } from 'ng-zorro-antd/resizable';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { removeRecentAgentAction } from 'src/app/actions/agent';
import { removeRecentCustomerAction } from 'src/app/actions/customer/action';
import { removeRecentProjectAction } from 'src/app/actions/project';
import { removeRecentStockAction } from 'src/app/actions/stock';
import { removeRecentTaxAction } from 'src/app/actions/tax';
import { removeRecentTermAction } from 'src/app/actions/term';
import { ColumnOptionsComponent } from 'src/app/components/col-options/col-options.component';
import { UserDefaultService } from 'src/app/shared/services/user-default.service';
import { DocEditActionsComponent } from 'src/app/shared-feature/components/actions/doc-edit-actions/doc-edit-actions.component';
import { FurtherDescriptionComponent } from 'src/app/shared-feature/components/f-desc/f-desc.component';
import { CustomerInfoModalComponent } from 'src/app/shared-feature/components/modal/customer-info-modal/customer-info-modal.component';
import { StockSelectComponent } from 'src/app/shared-feature/components/select/stock-select/stock-select.component';
import { DocBaseService } from 'src/app/shared-feature/services/_base/doc-base.service';
import { DocListBaseService } from 'src/app/shared-feature/services/_base/doc-list-base.service';
import { AutoCodeService } from 'src/app/shared-feature/services/auto-code.service';
import { TransactionDetailColumnAdjustService } from 'src/app/shared-feature/services/transaction-detail-column-adjust.service';
import { TranscationDetailKeyKownService } from 'src/app/shared-feature/services/transcation-detail-key-kown.service';

import { SdnListService } from '../../_providers/sdn-list.service';
import { SdnService } from '../../_providers/sdn.service';
import { PaginatedTableComponent } from 'src/app/shared/components/paginated-table/paginated-table.component';
import { AttachmentTableComponent } from 'src/app/shared/components/attachment-table/attachment-table.component';
import { AttachmentChangePayload } from 'src/app/shared/models/attachment-change.model';
@Component({
  selector: 'app-sdn-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.less'],
  standalone: false,
  providers: [
    {
      provide: DocListBaseService,
      useExisting: forwardRef(() => SdnListService)
    },
    {
      provide: DocBaseService,
      useExisting: forwardRef(() => SdnService)
    },
    {
      provide: SdnService,
      useFactory: (injector: Injector) => new SdnService(injector),
      deps: [Injector]
    },
    {
      provide: AutoCodeService,
      useFactory: (http: _HttpClient) => new AutoCodeService(http),
      deps: [_HttpClient]
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SdnDetailComponent 
  extends PaginatedTableComponent<SdnService>
  implements OnInit, AfterViewChecked, AfterViewInit, OnDestroy
{
  @ViewChild('custModal') customerInfoModal!: CustomerInfoModalComponent;
  @ViewChildren(StockSelectComponent)
  stockSelections!: QueryList<StockSelectComponent>;

  @ViewChild('notesTextArea') notesTextArea!: ElementRef;
  @ViewChild('columnOption') columnOptionComponent!: ColumnOptionsComponent;
  @ViewChild('itemDetailsTable', { static: false })
  nzTableComponent?: NzTableComponent<any>;
  @ViewChild('customerNameInput') customerNameInput!: any;
  @ViewChild('eInvStatus') eInvStatus!: EinvoiceStatusComponent;
  @ViewChild('docEditActions') docEditActions!: DocEditActionsComponent;
  @ViewChild('birComponent') birComponent!: any;
  @ViewChild('attachmentTable') attachmentTable!: AttachmentTableComponent;
  isEnableDeferredVatLookupSrv: boolean = true;
  private visibleColumnsChanged: boolean = false;
  private columnPositionReset: boolean = false;


  private initialColumnOrder: string[] = [];

  classificationOption = [...EINVOICE_STOCK_CLASSIFICATION];
  countries = [...COUNTRY_OPTIONS];
  paymTag = [...EINVOICE_PAYM];
  activeTabIndex = 0;
  recentStockControlIndex?: number;
  recentTaxControlIndex?: number;
  private destroy$ = new Subject<void>();
  get id() {
    return this.route.snapshot.params['id'];
  }
  get form() {
    return this.dataSrv.form;
  }
  get details() {
    return this.form.controls.itemDetails;
  }
  get country() {
    return this.settings.user['company'].country;
  }

  get collapsed() {
    return this.settings.layout.collapsed;
  }

  constructor(
    private route: ActivatedRoute,
    public msgSrv: NzMessageService,
    public override dataSrv: SdnService,
    public acl: ACLService,
    private modalSrv: NzModalService,
    override cdr: ChangeDetectorRef,
    public settings: SettingsService,
    public router: Router,
    public override keyDownService: TranscationDetailKeyKownService,
    public columnAdjustService: TransactionDetailColumnAdjustService,
    private injector: Injector,
    private store: Store<{
      term: { recentTerm: any };
      agent: { recentAgent: any };
      project: { recentProject: any };
      customer: { recentCustomer: any };
      stock: { recentStock: any };
      tax: { recentTax: any };
    }>,
    private userDefaultService: UserDefaultService
  ) {
    super(dataSrv, cdr, keyDownService);
    this.dataSrv.parentComponent = this;

    this.dataSrv.newLineAdded$.subscribe(() => {
      this.newlyAddedLine = true;
    });

    this.dataSrv.lineValueChanged.subscribe(({ line, controlName }) => {
      const index = this.dataSrv.itemDetails.controls.indexOf(line);
      this.keyDownService.focusNextElement(
        index,
        controlName,
        this.visibleColumns,
        this.editableCells.toArray()
      );
    });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  initialColumns: ColumnOptions[] = [];

  @ViewChildren('inputWrapper') inputWrappers!: QueryList<ElementRef>;

  ngOnInit(): void {
    this.checkDeferredVatSetting();
    this.dataSrv.setComponentRef(this);
    this.store.dispatch(removeRecentAgentAction());
    this.store.dispatch(removeRecentCustomerAction());
    this.store.dispatch(removeRecentProjectAction());
    this.store.dispatch(removeRecentTermAction());
    this.store.dispatch(removeRecentStockAction());
    this.store.dispatch(removeRecentTaxAction());
    if (this.id == 0) {
      this.onProjectCreate();
      this.onTermAdded();
      this.onAgentAdded();
      this.onAddNewCustomer();
      this.onStockCreate();
      this.onTaxCreate();
    }
  }

  checkDeferredVatSetting(){
    if (this.country === "PH"){
        this.injector.get(DeferredVatLookupService).loadDeferredVatSettings().subscribe(res => {
        this.isEnableDeferredVatLookupSrv = res === null ? false : res;
        this.dataSrv.form.controls.enableDeferredVat.setValue(this.isEnableDeferredVatLookupSrv);
      });
    }
  }

  private onTaxCreate() {
    this.store
      .select('tax')
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.recentTax === null) return;
        if (
          isNull(this.recentTaxControlIndex) ||
          isUndefined(this.recentTaxControlIndex) ||
          this.dataSrv.itemDetails.at(this.recentTaxControlIndex).controls
            .taxCode.value
        )
          return;
        const rowControl = this.dataSrv.itemDetails.at(
          this.recentTaxControlIndex
        );
        rowControl.controls.taxCode.setValue(state.recentTax);
        rowControl.controls.taxCodeId.setValue(state.recentTax.id);
      });
  }
  private onStockCreate() {
    this.store
      .select('stock')
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.recentStock === null) return;
        if (
          isNull(this.recentStockControlIndex) ||
          isUndefined(this.recentStockControlIndex) ||
          this.dataSrv.itemDetails.at(this.recentStockControlIndex).controls
            .taxCode.value
        )
          return;
        const rowControl = this.dataSrv.itemDetails.at(
          this.recentStockControlIndex
        );
        rowControl.controls.stock.setValue(state.recentStock);
        rowControl.controls.stockId.setValue(state.recentStock.id);
        rowControl.controls.stockLocation.setValue(state.recentStock.location);
        rowControl.controls.stockId.setValue(state.recentStock.locationId);
      });
  }
  private onProjectCreate() {
    this.store
      .select('project')
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.recentProject === null) return;
        if (
          this.form.controls.projectId.value ||
          this.form.controls.project.value
        )
          return;
        this.form.controls.project.setValue(state.recentProject);
        this.form.controls.projectId.setValue(state.recentProject.id);
      });
  }
  private onTermAdded() {
    this.store
      .select('term')
      .pipe(takeUntil(this.destroy$))
      .subscribe(term => {
        if (this.dataSrv.form.controls.termId.value) return;
        if (term.recentTerm) {
          this.dataSrv.form.controls.termId.setValue(term.recentTerm.id);
          this.dataSrv.form.controls.term.setValue(term.recentTerm);
        }
      });
  }
  private onAgentAdded() {
    this.store
      .select('agent')
      .pipe(takeUntil(this.destroy$))
      .subscribe(agent => {
        if (this.dataSrv.form.controls.agentId.value) return;
        if (agent.recentAgent) {
          this.dataSrv.form.controls.agentId.setValue(agent.recentAgent.id);
          this.dataSrv.form.controls.agent.setValue(agent.recentAgent);
        }
      });
  }
  onAddNewCustomer() {
    this.store
      .select('customer')
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.recentCustomer === null) return;
        this.form.controls.customer.setValue(state.recentCustomer);
        this.form.controls.customerId.setValue(state.recentCustomer?.id);
        this.form.controls.customerName.setValue(state.recentCustomer?.name);
        this.form.controls.customerPhone.setValue(
          state.recentCustomer?.phoneNo1
        );
        this.form.controls.customerTinType.setValue(
          state.recentCustomer?.tinType
        );
      });
  }
  ngAfterViewInit(): void {
    /**
     * column data should in take after onInit because to make the column chooser ngOninit data done processed
     * if not column in here will be overwrite by column chooser, the console log data will confused
     */

    this.visibleColumns = this.dataSrv.columns.filter(
      col => (!col.acl || this.acl.canAbility(col.acl)) && col.visible
    );

    this.initialColumns = JSON.parse(JSON.stringify(this.visibleColumns));
    this.initialColumnOrder = this.initialColumns.map(col => col.name);

    this.columnAdjustService.setInitialColumn(this.initialColumns);

    const savedOrder = this.columnAdjustService.loadColumnOrder('sdn');
    if (savedOrder) {
      this.visibleColumns.sort(
        (a, b) => savedOrder[a.key || ''] - savedOrder[b.key || '']
      );
    }

    // if column visible have update
    this.columnOptionComponent.visibleColiumnsChanged$.subscribe(() => {
      this.visibleColumnsChanged = true;
    });

    // if column position want to be reset
    this.columnOptionComponent.columnPositionReset$.subscribe(
      (initialOrder: string[]) => {
        this.initialColumnOrder = initialOrder;
        this.columnPositionReset = true;
      }
    );
    this.inputWrappers.forEach(wrapper => {
      this.userDefaultService.setRequiredValidation(wrapper);
    });
    this.dataSrv.validateTaxDate();
  }

  reload() {
    this.dataSrv.triggerEvent({ type: 'reload', id: this.dataSrv.id });
  }

  onResize({ width }: NzResizeEvent, col: any): void {
    col.width = `${width}px`;
  }

  populateDOAddress(data: any) {
    this.dataSrv.populateDOAddress(data);
  }

  updateLatestRate() {
    this.dataSrv.updateLatestRate();
  }

  get regNoLabel(): string {
    if (this.dataSrv.isEInvEnabled === true) {
      switch (this.dataSrv.form.controls.dotinType.value) {
        case 2:
          return 'Identification No.';
        case 4:
          return 'Passport No.';
        default:
          return 'Registration No.';
      }
    }
    return 'Registration No.';
  }

  get tinPlaceHolder(): string {
    if (this.dataSrv.isEInvEnabled === true) {
      switch (this.dataSrv.form.controls.customer.value) {
        case 1:
          return 'eg. C2584563202';
        case 2:
          return 'eg. IG56003500070';
        case 3:
          return 'eg. EI00000000010';
        case 4:
          return 'eg. EI00000000020';
        default:
          return '';
      }
    }
    return '';
  }

  get isConsolidated(): boolean {
    return this.dataSrv._data.consolidatedUIN
  }

  focusElement(name: string): boolean {
    if (
      name === 'identificationNo' ||
      name === 'doZipCode' ||
      name === 'doCity' ||
      name === 'doTINNo'
    ) {
      this.activeTabIndex = 3;
    } else if (name === 'detailsTaxExemption') {
      this.activeTabIndex = 1;
    } else {
      this.activeTabIndex = 0;
    }
    setTimeout(() => {
      this.dataSrv.fs.focusInvalidControl();
    }, 200);
    return true;
  }

  fDescriptionModal(line: any) {
    const modal = this.modalSrv.create({
      nzTitle: 'F. Desc',
      nzContent: FurtherDescriptionComponent,
      nzWidth: '800px',
      nzOnOk: component => {
        const instance = modal.getContentComponent();
        line.controls.docFurtherDescription.setValue(instance.getPersistedHtml());
      }
    });
    const instance = modal.getContentComponent();
    instance.fdescHtml = line.controls.docFurtherDescription.value;
  }

  updateCustModal(data: any) {
    this.dataSrv.updateCustInfo(data);
  }

  onCustomerChange() {
    if (this.dataSrv.editing){
      // Focus on customer name field after customer selection
      setTimeout(() => {
        if (this.customerNameInput) {
          this.customerNameInput.focus();
        }
      }, 100);
    }
  }

  openCustModal() {
    // Pass existing data to ensure data recovery can be done when changes are cancelled
    this.customerInfoModal.show(this.dataSrv.form.value, 'SDN');
  }

  ngAfterViewChecked() {
    if (this.newlyAddedLine) {
      this.focusNewLineStockSelect();
      this.newlyAddedLine = false;
    }

    // Phase 1: Update visible columns if there are changes
    if (this.visibleColumnsChanged) {
      // Create a map of the current visible columns
      const currentVisibleMap = new Map(
        this.visibleColumns.map(col => [col.name, col])
      );

      // Filter out columns that are no longer visible or accessible based on ACL
      this.visibleColumns = this.visibleColumns.filter(
        col =>
          (!col.acl || this.acl.canAbility(col.acl)) &&
          this.dataSrv.columns.find(c => c.name === col.name)?.visible
      );

      // Add any new visible columns that were not in the current map
      this.dataSrv.columns.forEach(col => {
        if (
          (!col.acl || this.acl.canAbility(col.acl)) &&
          col.visible &&
          !currentVisibleMap.has(col.name)
        ) {
          this.visibleColumns.push(col);
        }
      });

      // Reset the flag and detect changes to update the view
      this.visibleColumnsChanged = false;
      this.cdr.detectChanges();
    }

    // Phase 2: Reset column positions if requested
    if (this.columnPositionReset) {
      // Reorder the visible columns based on the initial column order
      this.visibleColumns = this.initialColumnOrder
        .map(name => this.visibleColumns.find(col => col.name === name))
        .filter(col => col !== undefined) as ColumnOptions[];

      // Reset the column order in the column adjust service
      this.columnAdjustService.resetColumnOrder('sdn');

      // Reset the flag and detect changes to update the view
      this.columnPositionReset = false;
      this.cdr.detectChanges();
    }
  }

  private focusNewLineStockSelect() {
    const stockSelectionArray = this.stockSelections.toArray();
    if (stockSelectionArray.length > 0) {
      const newLineStockSelect =
        stockSelectionArray[stockSelectionArray.length - 1];
      newLineStockSelect.focus();
    }
  }

  columnOrder: string[] = [];
  override selectComponentArray: string[] = [
    'stock',
    'project',
    'uom',
    'stockLocation',
    'taxCode',
    'wTaxCode',
    'account',
    'classification',
    'tariffCode',
    'taxAmountAdjustment',
    'wTaxAmountAdjustment'
  ];
  @ViewChildren('editableCell') override editableCells!: QueryList<ElementRef>;

  timestamp() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    var formattedTimestamp = null;
    if (this.settings.user['country'] === 'MY')
      formattedTimestamp = `${day}/${month}/${year} ${hours}:${minutes}:${seconds} - ${this.settings.user['displayName']}:`;
    if (this.settings.user['country'] === 'PH')
      formattedTimestamp = `${month}/${day}/${year} ${hours}:${minutes}:${seconds} - ${this.settings.user['displayName']}:`;
    if (this.dataSrv.form.controls.notes.value)
      formattedTimestamp = `${this.dataSrv.form.controls.notes.value}\n${formattedTimestamp}`;

    this.dataSrv.form.controls.notes.setValue(formattedTimestamp);
    this.notesTextArea.nativeElement.focus();
  }

  collectAttachmentChanges(): AttachmentChangePayload | null {
    if (this.attachmentTable && this.attachmentTable.getDeferredAttachmentChanges) {
      return this.attachmentTable.getDeferredAttachmentChanges();
    }
    return null;
  }

  clearAttachmentChanges(): void {
    if (this.attachmentTable && this.attachmentTable.clearDeferredChanges) {
      this.attachmentTable.clearDeferredChanges();
    }
  }
}
